module.exports = __webpack_public_path__ + "static/media/held_friday_participation.a3f4b12e.png";